export default "__VITE_ASSET__756609fd__"